import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { scheduleAnalytics } from "@/lib/analytics";
import { initialPage } from "@/redesign/initialPage";

let mount = document.getElementById("root");
if (initialPage) {
  mount = document.createElement("div");
  mount.id = "interactive-root";
  document.body.appendChild(mount);
}
const root = ReactDOM.createRoot(mount);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

scheduleAnalytics();
